const LIMIT_WARNING_THRESHOLD = 3;

export const useCampaignsLimitStatus = ({
  campaignsNumberLimit,
  activeCampaignsCount,
}: {
  campaignsNumberLimit?: number;
  activeCampaignsCount?: number;
}) => {
  if (campaignsNumberLimit == null || activeCampaignsCount == null) {
    return { hasReachedCampaignsLimit: false, hasReachedWarningThreshold: false };
  }

  return {
    hasReachedCampaignsLimit: activeCampaignsCount >= campaignsNumberLimit,
    hasReachedWarningThreshold: campaignsNumberLimit - activeCampaignsCount <= LIMIT_WARNING_THRESHOLD,
  };
};
